/**
 * Map GET /audit-logs rows to AuditLogPanel display shape.
 */

function titleCaseStatus(value) {
  if (value == null || value === "") return "—";
  const s = String(value).trim();
  const lower = s.toLowerCase();
  if (lower === "locked" || lower === "unlocked") {
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }
  return s;
}

/**
 * @param {Record<string, unknown>} row — API audit log row
 * @returns {{
 *   id: string;
 *   timestamp: string;
 *   user: string;
 *   action: string;
 *   month: string;
 *   previousStatus: string;
 *   newStatus: string;
 *   reason: string | null;
 * }}
 */
export function normalizeAuditLogApiItem(row) {
  const monthRaw = row.month ?? row.monthLabel ?? "";
  const month =
    monthRaw === "" || monthRaw == null
      ? "—"
      : typeof monthRaw === "string" && monthRaw.includes(" ")
        ? monthRaw
        : String(monthRaw);

  return {
    id: row.id != null ? String(row.id) : String(Math.random()),
    timestamp: row.createdAt ?? row.timestamp ?? new Date().toISOString(),
    user: row.actorName ?? row.user ?? "—",
    action: row.action != null ? String(row.action) : "—",
    month,
    previousStatus: titleCaseStatus(row.statusBefore ?? row.previousStatus),
    newStatus: titleCaseStatus(row.statusAfter ?? row.newStatus),
    reason: row.reason != null && row.reason !== "" ? String(row.reason) : null,
  };
}
